import { useGlobalUser } from "@/stores/globalUser";
import { useMateCommit } from "@/stores/mateCommit";
import { useNotification } from "@/stores/notification";
import { defineStore } from "pinia";
import { useCoinRank } from "./coinRank";

const INTERVAL = 3 * 60 * 1000;
const NO_INTERVAL = -1;

interface State {
  interval: number;
}

export const useGlobalInterval = defineStore("globalInterval", {
  state: (): State => {
    return {
      interval: -1,
    };
  },
  actions: {
    intervalTask() {
      useCoinRank().fetchIfCurrentRankExpired();
      const globalUser = useGlobalUser();
      if (!globalUser.isLogin) return;
      // const chatSession = useChatSession();
      return Promise.all([
        useNotification().refreshUnreadCount(),
        // chatSession.getUnreadCount(),
        // chatSession.fetchSessionOverviewList(),
        useMateCommit().getPendingList(),
      ]).catch(() => {
        // do nothing: 可能中间发生了Mate切换，导致请求失败
      });
    },
    registerInterval(immediate = false) {
      const globalUser = useGlobalUser();
      if (!globalUser.isLogin || this.interval !== NO_INTERVAL) {
        return;
      }
      if (immediate) {
        this.intervalTask();
      }
      this.interval = window.setInterval(() => {
        this.intervalTask();
      }, INTERVAL);
    },
    unregisterInterval() {
      if (this.interval !== NO_INTERVAL) {
        window.clearInterval(this.interval);
      }
    },
  },
});
